import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const toPlain = (d) =>
  d && {
    deviceId: d.deviceId,
    label: d.label || '',
    groupId: d.groupId || '',
  };

export const useSelectedDevices = () => {
  const {
    videoDeviceId,
    microphoneDeviceId,
    speakerDeviceId,
    videoinputDevices,
    audioinputDevices,
    audiooutputDevices,
  } = useSelector((s) => s.device, shallowEqual);

  return useMemo(
    () => ({
      video: toPlain(
        videoinputDevices.find((d) => d.deviceId === videoDeviceId)
      ),
      audio: toPlain(
        audioinputDevices.find((d) => d.deviceId === microphoneDeviceId)
      ),
      audioOutput: toPlain(
        audiooutputDevices.find((d) => d.deviceId === speakerDeviceId)
      ),
    }),
    [
      videoDeviceId,
      microphoneDeviceId,
      speakerDeviceId,
      videoinputDevices,
      audioinputDevices,
      audiooutputDevices,
    ]
  );
};
